export const scrollTo = (x: number, y: number): void => window.scrollTo(x, y);
